export default __webpack_public_path__ + "static/media/disconnected-indicator 2.89e9fbff.svg";